import api from "./axios";
import type { Review, Statistics } from "@/types";

export const getAll = (params?: {
  restaurantId?: string;
  userId?: string;
  eventId?: string;
}) => api.get<Review[]>("/reviews", { params }).then((r) => r.data);

export const getById = (id: string) =>
  api.get<Review>(`/reviews/${id}`).then((r) => r.data);

export const create = (data: {
  restaurantId: string;
  eventId?: string;
  ambient: number;
  service: number;
  speed: number;
  starters: number;
  mains: number;
  deserts: number;
  title?: string;
  comment?: string;
}) => api.post<Review>("/reviews", data).then((r) => r.data);

export const update = (id: string, data: Record<string, unknown>) =>
  api.patch<Review>(`/reviews/${id}`, data).then((r) => r.data);

export const remove = (id: string) =>
  api.delete(`/reviews/${id}`).then((r) => r.data);

export const getStatistics = () =>
  api.get<Statistics>("/reviews/stats").then((r) => r.data);
